import { Button } from "../../components/ui/button";
import { ArrowRight, Linkedin } from "lucide-react";
import headshot from "../../assets/uday-headshot.jpg";

export function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-gradient-hero pt-32 pb-20 md:pt-40 md:pb-28"
    >
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 md:grid-cols-2 md:gap-16">
        <div className="flex flex-col gap-6">
          <p className="font-mono text-sm font-medium tracking-wide text-primary">
            // Hello, I&apos;m Uday Manvar
          </p>
          <h1 className="text-4xl font-bold leading-[1.1] tracking-tight text-foreground md:text-5xl lg:text-6xl">
            Technical Lead & <span className="text-gradient"> Full-Stack Architect</span>
          </h1>
          <p className="max-w-xl text-base leading-relaxed text-muted-foreground md:text-lg">
            Over the last decade, I’ve bridged the gap between product vision and technical execution. With a track record of delivering over many successful projects, I specialize in building scalable applications, mentoring high-performing engineering teams, and leveraging AI and intelligent automation to accelerate development workflows. I don't just write code; I engineer solutions that drive business growth.
          </p>
          <div className="mt-2 flex flex-wrap gap-4">
            <Button asChild variant="hero" size="lg">
              <a href="#projects">
                View My Work <ArrowRight className="ml-1 h-4 w-4" />
              </a>
            </Button>
            <Button asChild variant="outline-glow" size="lg">
              <a href="https://www.linkedin.com/in/udaymanvar/" target="_blank" rel="noreferrer">
                <Linkedin className="mr-1 h-4 w-4" /> Connect on LinkedIn
              </a>
            </Button>
          </div>
        </div>

        <div className="relative mx-auto flex w-full max-w-md items-center justify-center md:max-w-none">
          <div
            className="absolute inset-0 -z-10 animate-pulse-glow rounded-full blur-3xl"
            style={{ background: "var(--gradient-glow)" }}
          />
          {
            <div className="relative aspect-[4/5] w-full max-w-sm overflow-hidden rounded-2xl border border-border shadow-elevated">
              <img
                src={headshot}
                alt="Portrait of Uday, Software Engineering Lead"
                width={768}
                height={896}
                className="h-full w-full object-cover"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-background/60 via-transparent to-primary/10" />
            </div>
          }
        </div>
      </div>
    </section>
  );
}
